import { ProductsType } from 'src/constants/products';
import { AgentCoSupportIcon } from 'src/assets/icons/agentCoSupportIcon';
import { CustomerCoSupportIcon } from 'src/assets/icons/customerCoSupportIcon';
import { BiCoSupportIcon } from 'src/assets/icons/biCoSupportIcon';
import { Button } from 'src/components/ui/button';
import { setProjectId } from 'src/store/slices/projectsSlices';
import { useAppDispatch } from 'src/store';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import { Link } from 'react-router-dom';
import { clsx } from 'clsx';
import type { ProductKey } from 'src/constants/products';

const PRODUCT_CONTENT: Partial<
  Record<ProductKey, { icon: JSX.Element; title: string; description: string }>
> = {
  [ProductsType.agent]: {
    icon: <AgentCoSupportIcon width="19" height="19" />,
    title: 'AI Assistant',
    description: 'Generate smart reply suggestions for support agents inside a help desk.',
  },
  [ProductsType.customer]: {
    icon: <CustomerCoSupportIcon width="19" height="19" />,
    title: 'AI Agent',
    description: 'Automate the resolution process for chats, emails and social media channels.',
  },
  [ProductsType.bi]: {
    icon: <BiCoSupportIcon width="19" height="19" />,
    title: 'AI BI',
    description: 'Turn internal data and customer correspondence into actionable insights.',
  },
};

const getCreateLink = (type: ProductKey, isAdmin: boolean, navigationLink: string) => {
  if (type === ProductsType.customer) return `${PATH_DASHBOARD.PROJECTS_NEW_STEP_1}?type=${type}`;
  if (isAdmin) return `${PATH_DASHBOARD.PROJECTS_NEW}?type=${type}`;
  return navigationLink;
};

export const CreateNewAgentCard = ({
  type = ProductsType.agent,
  isAdmin = true,
  navigationLink = '',
  disabled = false,
}: {
  type?: ProductKey;
  isAdmin?: boolean;
  navigationLink?: string;
  disabled?: boolean;
}) => {
  const dispatch = useAppDispatch();

  const addProjectHandler = (projectType: ProductKey) => {
    if (!disabled) {
      dispatch(setProjectId({ projectType }));
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  const content = PRODUCT_CONTENT[type];

  return (
    <div className="w-full p-5 pt-[25px] relative border shadow rounded-sm-5 shadow-[#00000040] border-[#E3E6E8] transition-all">
      <div className="flex gap-2 items-center">
        {content?.icon}
        <p className="text-base font-jamjuree font-semibold">{content?.title}</p>
      </div>
      <p className="text-sm font-jamjuree font-medium opacity-50 text-start pt-2.5 pb-[15px]">
        {content?.description}
      </p>
      <Link
        className={clsx(disabled && 'pointer-events-none')}
        target={!disabled && !isAdmin ? '_blank' : '_self'}
        onClick={() => addProjectHandler(type)}
        to={disabled ? '' : getCreateLink(type, isAdmin, navigationLink)}
      >
        <Button disabled={disabled} className="w-full">
          {isAdmin ? 'Create' : 'Request Access'}
        </Button>
      </Link>
    </div>
  );
};
